/* eslint-disable no-useless-computed-key */
/* eslint-disable import/prefer-default-export */
import { makeStyles } from '@material-ui/core/styles';
import ContactUsBg from '../../images/contact_us.png';
import MaterialsBg from '../../images/materials.png';

export const applyStyles = makeStyles(() => ({
  container: {
    background: `#E1E1E1`,
    height: '120px',
    backgroundSize: 'cover',
    position: 'sticky',
    bottom: -1,
    zIndex: 7,
    '@media (max-width: 1024px)': {
      padding: '24px 0',
      bottom: 0,
      height: 'auto',
    },
  },
  wrapper: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '@media (max-width: 1024px)': {
      flexDirection: 'column',
      gap: 10,
    },
  },
  materials: {
    display: 'block',
    marginLeft: 32,
    '@media (max-width: 1024px)': {
      marginLeft: 0,
    },
  },
  button: {
    fontFamily: 'Noto Sans JP',
    width: '328px',
    padding: '16px',
    borderRadius: '28px',
    background: 'linear-gradient(90deg, #E5258C 0%, #863BD4 96.36%)',
    font: '600 16px/24px normal',
    display: 'flex',
  },
}));

export const benefitsStyles = makeStyles((theme) => ({
  title: {
    color: '#101825',
    '@media (max-width: 1024px)': {
      fontSize: '28px',
      lineHeight: '34px',
      padding: '0 34px',
      fontWeight: 900,
    },
  },
  figureWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 64,
    '@media (max-width: 1024px)': {
      flexDirection: 'column',
      justifyContent: 'center',
      marginTop: 40,
    },
  },
  figure: {
    color: '#101825',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: theme.spacing(7.5),
    flex: 1,
    '@media (max-width: 1024px)': {
      margin: '0 30px 60px',
      textAlign: 'center',
    },
    '&:last-child': {
      marginRight: 0,
      '@media (max-width: 1024px)': {
        margin: '0 30px 60px',
      },
    },
    '& > p': {
      marginTop: theme.spacing(3),
      '@media (max-width: 1024px)': {
        width: '360px',
        textAlign: 'left',
      },
      '@media (max-width: 767.98px)': {
        width: 'initial',
      },
    },
  },
}));

export const contactUsStyles = makeStyles(() => ({
  container: {
    color: '#101825',
    background: `url(${ContactUsBg}) left top no-repeat`,
    height: '470px',
    backgroundSize: 'cover',
    '@media (max-width: 1024px)': {
      background: 'linear-gradient(327deg, #DAD2D0 -19.5%, #F3EFEA 95.94%)',
      padding: '64px 24px',
    },
    '& > div': {
      height: '100%',
    },
  },
  wrapper: {
    alignItems: 'flex-start',
    '@media (max-width: 1024px)': {
      alignItems: 'center',
    },
  },
  title: {
    '@media (max-width: 1024px)': {
      fontSize: '28px',
      lineHeight: '40px',
    },
  },
  button: {
    width: '343px',
    height: '56px',
    borderRadius: '28px',
    background: 'linear-gradient(90deg, #E5258C 0%, #863BD4 96.36%)',
    font: '600 16px/24px normal',
    display: 'flex',
    '@media (max-width: 1024px)': {
      width: '264px',
      height: '48px',
      padding: '16px',
    },
  },
}));

export const demoStyles = makeStyles((theme) => ({
  container: {
    color: '#101825',
    padding: '100px 0',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    '@media (max-width: 1024px)': {
      padding: '80px 0 60px',
    },
    '& figcaption': {
      margin: `${theme.spacing(1)}px 0`,
    },
  },
  title: {
    '@media (max-width: 1024px)': {
      fontSize: '28px',
      lineHeight: '40px',
    },
  },
  button: {
    color: 'white',
    font: '600 16px/24px normal',
    display: 'flex',
    width: '328px',
    padding: '16px',
    borderRadius: '28px',
    background: '#404042',
    '&:hover': {
      background: '#404042',
    },
  },
  stepsImg: {
    width: '79%',
    marginTop: 70,
    display: 'inline-block',
    '@media (max-width: 1024px)': {
      display: 'none',
    },
  },
  steps: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: '64px',
    '@media (max-width: 1024px)': {
      marginBottom: '70px',
      marginTop: '40px',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    '& figure': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  step: {
    width: '25%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  stepSp: {
    display: 'none',
    '@media (max-width: 1024px)': {
      display: 'block',
    },
  },
  stepImg: {
    width: '161px',
    height: '161px',
    display: 'flex',
    alignItems: 'center',
    '& > img': {
      width: '100%',
      height: 'auto',
      margin: '0 auto',
    },
    [theme.breakpoints.down('md')]: {
      width: '140px',
      margin: '0 auto',
    },
    '@media (max-width: 1024px)': {
      width: '161px',
      height: '161px',
    },
  },
  lastStepImg: {
    '& > img': {
      width: '141px',
      [theme.breakpoints.down('md')]: {
        width: '110px',
      },
      '@media (max-width: 1024px)': {
        width: '141px',
      },
    },
  },
  arrow: {
    width: 0,
    height: 0,
    borderTop: '8px solid transparent',
    borderBottom: '8px solid transparent',
    borderLeft: '10px solid #000',
    alignSelf: 'center',
    margin: '-40px 10px 0',
    '@media (max-width: 1024px)': {
      margin: '30px 0 10px',
      transform: 'rotate(90deg)',
    },
  },
}));

export const materialsStyles = makeStyles(() => ({
  container: {
    height: '306px',
    background: `url(${MaterialsBg})`,
    backgroundSize: 'cover',
    '@media (max-width: 1024px)': {
      height: '420px',
      background: `linear-gradient(327deg, #DAD2D0 -19.5%, #F3EFEA 95.94%)`,
      backgroundSize: 'cover',
    },
    '& > div': {
      height: '100%',
    },
  },
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'center',
    height: '100%',
  },
  title: {
    color: '#101825',
    '@media (max-width: 1024px)': {
      fontSize: '28px',
      lineHeight: '40px',
    },
  },
  description: {
    margin: '40px 0',
    '@media (max-width: 1024px)': {
      marginTop: '44px',
      marginBottom: '44px',
      width: '310px',
      textAlign: 'left',
    },
  },
  button: {
    color: 'white',
    font: '600 16px/24px normal',
    display: 'flex',
    width: '328px',
    padding: '16px',
    borderRadius: '28px',
    background: '#404042',
    '&:hover': {
      background: '#404042',
    },
  },
}));

export const navigationStyles = makeStyles((theme) => ({
  wrapper: {
    background: '#FAFAFA',
    '@media (max-width: 1024px)': {
      paddingTop: 'initial',
    },
  },
  header: {
    backgroundColor: 'white',
    position: 'sticky',
    // paddingTop: theme.spacing(3),
    top: '64px',
    zIndex: 1,
    [theme.breakpoints.down('md')]: {
      // paddingTop: '20px',
      top: '55px',
    },
    ['@media (max-device-width: 1366px)']: {
      paddingTop: '20px',
      top: '55px',
    },
    '@media (max-width: 1024px)': {
      paddingTop: 0,
      top: '55px',
      overflow: 'auto',
      whiteSpace: 'nowrap',
    },
  },
}));

export const postpaymentsStyles = makeStyles((theme) => ({
  container: {
    paddingTop: '88px',
    paddingBottom: '88px',
    '@media (max-width: 1024px)': {
      paddingBottom: '64px',
      paddingLeft: '48px',
      paddingRight: '48px',
    },
    '@media (max-width: 767.98px)': {
      paddingLeft: '16px',
      paddingRight: '16px',
    },
  },
  gridContainer: {
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center',
    },
  },
  sp: {
    display: 'none',
    '@media (max-width: 1024px)': {
      display: 'flex',
      justifyContent: 'center',
    },
  },
  textContainer: {
    width: '100%',
    maxWidth: 489,
    [theme.breakpoints.down('md')]: {
      maxWidth: 310,
    },
  },
  title: {
    color: '#101825',
    marginTop: 'initial',
    marginBottom: '32px',
    textAlign: 'left',
    fontSize: 28,
    fontWeight: 900,
    lineHeight: '40px',
    letterSpacing: '0.4836362898349762px',
    '@media (max-width: 1024px)': {
      marginTop: '32px',
      marginBottom: '32px',
      textAlign: 'center',
    },
  },
  description: {
    color: '#101825',
    fontSize: 16,
    fontWeight: 400,
    lineHeight: '24px',
    '@media (max-width: 1024px)': {
      paddingRight: 'initial',
    },
  },
  postpaymentSec: {
    width: '100%',
    overflow: 'hidden',
  },
  pc: {
    display: 'block',
    alignSelf: 'flex-start',
    '@media (max-width: 1024px)': {
      display: 'none',
    },
  },
  postpaymentsImg: {
    width: 460,
    height: 360,
    [theme.breakpoints.down('md')]: {
      width: '100%',
      maxWidth: 310,
      height: 'auto',
    },
  },
  textSubtitle: {
    fontSize: 13,
    fontWeight: 400,
    lineHeight: '18px',
  },
  divider: {
    '@media (max-width: 1024px)': {
      paddingBottom: 16,
    },
  },
}));

export const paidyPartnerStyles = makeStyles(() => ({
  container: {
    padding: '88px 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    '@media (max-width: 1024px)': {
      padding: '72px 0',
      background: 'white',
    },
    '@media (max-width: 374.98px)': {
      padding: '72px 0',
    },
  },
  headline: {
    fontWeight: '900',
    color: '#101825',
    '@media (max-width: 1024px)': {
      fontSize: '28px',
      lineHeight: '40px',
    },
  },
  typeWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    maxWidth: '820px',
    margin: '64px auto 48px',
    '@media (max-width: 1024px)': {
      flexDirection: 'column',
      alignItems: 'center',
      margin: '60px auto 0',
    },
    '@media (max-width: 374.98px)': {
      maxWidth: '100%',
    },
  },
  partnerType: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '@media (max-width: 1024px)': {
      marginBottom: '60px',
    },
  },
  logoImg: {
    paddingRight: '17px',
    '@media (max-width: 374.98px)': {
      paddingRight: '12px',
    },
  },
  titleWrapper: {
    borderLeft: '2px solid #DEBCBC',
    paddingLeft: '15px',
    textAlign: 'left',
    '@media (max-width: 374.98px)': {
      paddingLeft: '10px',
    },
  },
  title: {
    textTransform: 'uppercase',
    letterSpacing: '10px',
    '@media (max-width: 374.98px)': {
      letterSpacing: '6px',
      fontSize: '20px',
    },
  },
  highlight: {
    color: '#E52581',
  },
  description: {
    fontSize: '13px',
    '@media (max-width: 1024px)': {
      fontSize: '12px',
    },
    '@media (max-width: 374.98px)': {
      fontSize: '10px',
    },
  },
  textWrapper: {
    marginBottom: '92px',
    textAlign: 'left',
    width: '698px',
    margin: '0 auto 64px',
    '@media (max-width: 1024px)': {
      width: '100%',
      margin: '0 auto 40px',
    },
  },
  text: {
    '@media (max-width: 1024px)': {
      padding: '0 24px',
    },
  },
  button: {
    color: 'white',
    font: '600 16px/24px normal',
    display: 'flex',
    width: '328px',
    padding: '16px',
    borderRadius: '28px',
    background: '#404042',
    '&:hover': {
      background: '#404042',
    },
  },
}));

export const caseStudiesStyles = makeStyles(() => ({
  wrapper: {
    padding: '64px',
    backgroundColor: '#F0F0F0',
    '@media (max-width: 1024px)': {
      padding: '0 0 64px 0',
    },
  },
  titleWrapper: {
    marginBottom: '64px',
    '@media (max-width: 1024px)': {
      padding: 0,
      fontSize: '28px',
      lineHeight: '40px',
      marginBottom: 40,
    },
  },
  title: {
    color: '#101825',
    '@media (max-width: 1024px)': {
      fontSize: '28px',
      lineHeight: '40px',
    },
  },
}));

export const clientsStyles = makeStyles(() => ({
  wrapper: {
    padding: '64px 0',
  },
  title: {
    color: '#101825',
    '@media (max-width: 1024px)': {
      fontSize: '28px',
      lineHeight: '40px',
      fontWeight: 900,
    },
  },
  subTitleWrapper: {
    marginTop: '64px',
    '@media (max-width: 1024px)': {
      marginTop: '40px',
      marginBottom: '40px',
    },
  },
  subTitle: {
    color: '#101825',
    '@media (max-width: 1024px)': {
      fontSize: '18px',
      lineHeight: '32px',
      letterSpacing: '0.622px',
      padding: '0 59px',
    },
  },
  pc: {
    display: 'block',
    '@media (max-width: 767.98px)': {
      display: 'none',
    },
  },
  sp: {
    display: 'none',
    '@media (max-width: 767.98px)': {
      display: 'block',
    },
  },
}));

export const howToUseStyles = makeStyles(() => ({
  wrapper: {
    padding: '88px 0',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '64px',
    '@media (max-width: 1024px)': {
      paddingTop: '32px',
      gap: '40px',
    },
  },
  video: {
    width: '50%',
    '@media (max-width: 1024px)': {
      width: '100%',
      padding: '0 14px',
    },
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '32px',
    '@media (max-width: 1024px)': {
      marginLeft: 'initial',
      alignItems: 'center',
    },
    width: '380px',
  },
  subtitleText: {
    color: '#101825',
    font: '900 28px/40px normal',
    letterSpacing: '0.484px',
    '@media (max-width: 1024px)': {
      textAlign: 'left',
      font: '900 24px/34px normal',
      padding: '0 14px',
    },
  },
  description: {
    margin: 'initial',
    font: '400 16px/24px normal',
    '@media (max-width: 1024px)': {
      padding: '0 14px',
    },
  },
}));

export const supportStyles = makeStyles(() => ({
  wrapper: {
    color: '#101825',
    height: '132px',
    flexDirection: 'row',
    textAlign: 'left',
    '@media (max-width: 1024px)': {
      height: '216px',
      flexDirection: 'column',
      textAlign: 'center',
    },
  },
  title: {
    marginRight: '72px',
    marginBottom: 'initial',
    '@media (max-width: 1024px)': {
      marginRight: 'initial',
      marginBottom: '32px',
    },
  },
  buttonPrimary: {
    background: 'linear-gradient(135deg, #E5258C 0%, #823CD7 100%)',
    width: '328px',
  },
}));

export const videoStyles = makeStyles(() => ({
  wrapper: {
    minHeight: '700px',
    '@media (max-width: 1024px)': {
      minHeight: '180px',
    },
  },
}));
